// MED-7: Server Component — `new Date()` no render é determinístico.

import React from 'react';
import { APP_VERSION } from '@/lib/app-version';

interface AppFooterProps {
  className?: string;
}

export default function AppFooter({ className = '' }: AppFooterProps) {
  const year = new Date().getFullYear();

  return (
    <footer
      role="contentinfo"
      className={`shrink-0 border-t border-border bg-muted/25 px-3 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] text-center text-[10px] leading-snug text-muted-foreground sm:px-4 sm:py-2.5 sm:text-[11px] lg:px-6 ${className}`.trim()}
    >
      <div className="flex flex-col items-center gap-0.5 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-1.5">
        <span className="text-foreground/80">© {year} Metrica Leilões</span>
        <span className="hidden sm:inline opacity-50" aria-hidden>
          ·
        </span>
        <span>Todos os direitos reservados</span>
        <span className="hidden sm:inline opacity-50" aria-hidden>
          ·
        </span>
        <span className="tabular-nums sm:ml-0">Versão {APP_VERSION}</span>
      </div>
    </footer>
  );
}
